import React, { useState } from "react";
import Login from "./components/Login";
import Header from "./components/Header";
import Standings from "./components/Standings";
import Teams from "./components/Teams";
import GameScoring from "./components/GameScoring";
import Stats from "./components/Stats";

function App() {
  const [view, setView] = useState("login");
  const [isAdmin, setIsAdmin] = useState(false);
  const [tab, setTab] = useState("standings");

  if (view === "login") {
    return (
      <Login
        onAdmin={() => { setIsAdmin(true); setView("app"); }}
        onGuest={() => { setIsAdmin(false); setView("app"); }}
      />
    );
  }

  return (
    <div style={{ background: "#0d1117", minHeight: "100vh", color: "#e6edf3", fontFamily: "sans-serif" }}>
      <Header isAdmin={isAdmin} />

      <div style={{ paddingBottom: 80 }}>
        {tab === "standings" && <Standings isAdmin={isAdmin} />}
        {tab === "teams"     && <Teams />}
        {tab === "games" && <GameScoring isAdmin={isAdmin} />}
        {tab === "stats" && <Stats />}
      </div>

      <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, background: "#161b22", borderTop: "1px solid #30363d", display: "flex" }}>
        {[
          { id: "standings", label: "Standings", icon: "🏆" },
          { id: "teams",     label: "Teams",     icon: "👥" },
          { id: "games",     label: "Games",     icon: "⚾" },
          { id: "stats",     label: "Stats",     icon: "📊" },
        ].map(item => (
          <button
            key={item.id}
            onClick={() => setTab(item.id)}
            style={{
              flex: 1, background: "transparent", border: "none",
              padding: "10px 4px 12px", cursor: "pointer",
              display: "flex", flexDirection: "column", alignItems: "center", gap: 3
            }}
          >
            <span style={{ fontSize: 22 }}>{item.icon}</span>
            <span style={{ fontSize: 11, color: tab === item.id ? "#388bfd" : "#7d8590", fontWeight: tab === item.id ? 700 : 400 }}>
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default App;